import { ref, type Ref } from 'vue';

export type Pagination = {
    isFirstPage: boolean;
    isLastPage: boolean;
    page: number;
    min: number;
    max: number;
    set: (page: number) => void;
    prev: () => void;
    next: () => void;
};

export type PaginationArgs = {
    min: number;
    max: number;
    page?: number;
};

const pagination: Ref<Pagination> = ref({
    min: 1,
    max: 1,
    page: 1,
    isFirstPage: true,
    isLastPage: true,
} as Pagination);

const useQuestionPagination = (args?: PaginationArgs) => {
    if (args) {
        const { min, max, page } = args;
        pagination.value = {
            ...pagination.value,
            isFirstPage: page === min,
            isLastPage: page === max,
            page: page ?? min,
            min,
            max,
            set: (setPage: number) => {
                pagination.value.page = setPage;
                pagination.value.isFirstPage = setPage === pagination.value.min;
                pagination.value.isLastPage = setPage === pagination.value.max;
            },
            prev: () => {
                if (pagination.value.page > pagination.value.min) {
                    pagination.value.page -= 1;
                    pagination.value.isFirstPage = pagination.value.page === pagination.value.min;
                    pagination.value.isLastPage = false;
                }
            },
            next: () => {
                if (pagination.value.page < pagination.value.max) {
                    pagination.value.page += 1;
                    pagination.value.isFirstPage = false;
                    pagination.value.isLastPage = pagination.value.page === pagination.value.max;
                }
            },
        };
    }

    return pagination;
};

export default useQuestionPagination;
